import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, effect, DestroyRef, inject } from '@angular/core';
import { HuddlesService } from 'src/app/shared/services/huddle/huddles.service';
import { DatePipe, NgIf, NgFor } from '@angular/common';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { AccountsService } from 'src/app/shared/services/accounts/accounts.service';
import * as _ from 'lodash';
import { FeedsService } from 'src/app/shared/services/feeds/feeds.service';
import * as moment from 'moment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { OverviewTableComponent } from '../../../../../shared/components/score/score-overview/sub-component/overview-table/overview-table.component';
import { LtmsErrorComponent } from '../../../../../shared/components/ltms-error/ltms-error.component';
import { LtmsLoaderComponent } from '../../../../../shared/components/ltms-loader/ltms-loader.component';
import { SuggestionEditModalComponent } from '../../suggestion-edit-modal/suggestion-edit-modal.component';

@Component({
    selector: 'app-all-suggestions',
    templateUrl: './all-suggestions.component.html',
    styleUrls: ['./all-suggestions.component.scss'],
    providers: [DatePipe],
    imports: [NgIf, FormsModule, NgFor, OverviewTableComponent, LtmsErrorComponent, LtmsLoaderComponent, SuggestionEditModalComponent]
})
export class AllSuggestionsComponent implements OnInit, AfterViewInit {
  @ViewChild('litmussearchdropdown') litmusfeedsearch!: ElementRef;
  destroyRef = inject(DestroyRef);
  suggestionsData: any[] = [];
  originalSuggestionsData: any[] = [];
  filteredSuggestionsData: any[] = [];
  suggestionFilteredTagFields: any[] = [];
  expandedRowIndex: number | null = null;
  huddleBrandId: string | null = null;
  escalations: string | null = null;
  currentPage: number = 1;
  recordsPerPage: number = 10;
  toData: number = this.recordsPerPage;
  isLoading: boolean = true;
  fromDate: any = '';
  toDate: any = '';
  selected_level: string = '';
  selected_value: any;
  hierarchyStack: any;
  isMergSuggestionActive: boolean = false;
  showEditModal: boolean = false;

  brandId: string = '';
  brandDetails: any = {};
  suggestionToBeMerged: any = {};
  suggestionConfig: any = {}
  suggestionBrandId: string = '';
  suggestionsDetails: any = {}

  tableConfigs: any = {
    showCheckbox: false,
    isRowEditable: true,
    textWrap: true,
    isExternalSort: true,
    theme: "theme-2"
  }
  suggestionTable: any = {
    fixedHeader: [
      {
        header: 'Dates',
        uniqueId: 'formated_created_date',
        sortId: 'created_date_in_ms',
        width: '120px',
        maxWidth: '300px',
        minWidth: '200px',
        isSortingEnabled: true,
        sort_order: 'desc',
        isClickable: true,
        style: {
          header: 'flex-start',
          row: 'flex-start'
        }
      },
      {
        header: 'Branch',
        uniqueId: "tag_meeting_name",
        width: '300px',
        maxWidth: '300px',
        minWidth: '300px',
        isSortingEnabled: false,
        // isClickable: true,
        style: {
          header: 'flex-start',
          row: 'flex-start'
        },
        textStyle: {
          whiteSpace: 'wrap'
        }
      }
    ],
    header:
      [

        {
          header: "Problem Statement",
          uniqueId: "tag_ltms_huddle_suggestions_for_process_imporvement_item_description_1",
          width: '700px',
          maxWidth: '700px',
          minWidth: '700px',
          isSortingEnabled: false,
          // isClickable: true,
          style: {
            header: 'flex-start',
            row: 'flex-start',
            textWrap: 'wrap'
          },
          textStyle: {
            whiteSpace: 'wrap'
          }
        },
        {
          header: "Recommendation/Suggestion",
          uniqueId: "tag_ltms_huddle_suggestions_for_process_imporvement_recommendation_1",
          width: '700px',
          maxWidth: '700px',
          minWidth: '700px',
          isSortingEnabled: false,
          // isClickable: true,
          style: {
            header: 'flex-start',
            row: 'flex-start',
            textWrap: 'wrap'
          },
          textStyle: {
            whiteSpace: 'wrap'
          }
        },
        {
          header: "Theme",
          uniqueId: "tag_ltms_huddle_suggestions_for_process_imporvement_theme_1",
          width: '20px',
          maxWidth: '300px',
          minWidth: '200px',
          isSortingEnabled: false,
          style: {
            header: 'flex-start',
            row: 'flex-start'
          },
          textStyle: {
            whiteSpace: 'wrap'
          }
        },
        {
          header: "Reason",
          uniqueId: "tag_ltms_huddle_suggestions_for_process_imporvement_sub_reason_1",
          width: '700px',
          maxWidth: '700px',
          minWidth: '700px',
          isSortingEnabled: false,
          style: {
            header: 'flex-start',
            row: 'flex-start'
          },
          textStyle: {
            whiteSpace: 'wrap'
          }
        },
        {
          header: "Product",
          uniqueId: "tag_ltms_huddle_suggestions_for_process_imporvement_product_and_function_1",
          width: '120px',
          maxWidth: '300px',
          isSortingEnabled: false,
          style: {
            header: 'flex-start',
            row: 'flex-start'
          },
          textStyle: {
            whiteSpace: 'wrap'
          }
        },
        {
          header: "Status",
          uniqueId: "tag_ltms_huddle_suggestions_for_process_imporvement_status_1",
          width: '200px',
          maxWidth: '300px',
          minWidth: '210px',
          isSortingEnabled: false,
          style: {
            header: 'flex-start',
            row: 'flex-start'
          },
          textStyle: {
            whiteSpace: 'wrap'
          }
        }
      ],
    rows: []
  };
  managerAccessDetail: any = null
  customFilterList: any = null;
  managerHasMergeAccess: boolean = false;
  filters: any = {
    fieldToSortOn: null,
    fieldSortOrder: null,
    dateSortOrder: 'desc',
    nonExistantFields: null,
    defaultNonExistantField: ["sibling_feed_id_list"],
    fieldToSearchOn: null,
    textToSearch: null
  }

  isSuggestionAvailble: boolean = false;

  isSearchEnabled: boolean = false;
  showSearchList: boolean = false;
  showFilterFields: boolean = false;
  searchText: string = '';
  defaultSearchField: any = null;
  selectedSearchField: any = null;
  searchableFieldList: any = []
  suggestionSearch: any = {
    selectedOption: {},
    selectedFilter: {},
    placeholder: "Please search and select",
    options: [],
  }

  clearField: any = {
    isError: false,
    displayText: 'clear',
    isEnabled: false
  }

  filterFrom: number = 0;
  filterLimit: number = 10;
  isOptionLoading: boolean = false;

  searchResult: any = {}

  escalationList: any = []
  isMergeButtonEnabled: boolean = false;
  modalDetail: any = {}

  isDataLoaded: boolean = false;
  pagingDetails: any = {
    start: 0,
    end: 0,
    pageSize: 10,
    pageNumber: 1,
    total: 0,
    totalpages: 1
  }
  pagingButtons: any = {
    isNext: false,
    isPrevious: false,
    isLast: false,
    isFirst: false
  }

  constructor(
    private huddlesService: HuddlesService,
    private helperService: HelpersService,
    private _toast: ToastService,
    private _accountsService: AccountsService,
    private _stateService: AppStateService,
    private _feedService: FeedsService,
  ) {
    effect(() => {
      if (this._stateService.initialized()) {
        const state: any = this._stateService.appState();
        if (state && this.checkRequiredPamater(state)) {
          this.fromDate = state.datePicker.startDate;
          this.toDate = state.datePicker.endDate;
          if (state.hierarchyStack && state.hierarchyStack.length) {
            this.managerAccessDetail = {
              "level": state.hierarchyStack[0].field_id,
              "value": state.hierarchyStack[0].group_key[0]
            }
          }
          if (this.brandId != state.brandDetails._id) {
            this.brandDetails = state.brandDetails;
            this.brandId = state.brandDetails._id;
            

            this.suggestionConfig = _.get(this.brandDetails, "action_management_configuration.huddle.modules.escalations");
            this.suggestionBrandId = _.get(this.suggestionConfig, "config.brand_id");
            if (this.suggestionBrandId && this.suggestionBrandId != '') {
              this._accountsService.getBrandDetail(this.suggestionBrandId).subscribe((response: any) => {
                if (response && response.code == 0 && _.hasIn(response, 'data.brand') && !_.isEmpty(response.data.brand)) {
                  // this.managerAccessDetail = this.helperService.getLoggedInAccessLevelAndValue();

                  if (this.managerAccessDetail) {
                    this.managerHasMergeAccess = this.huddlesService.updateManagerHuddleMergeAccess(this.managerAccessDetail, this.brandDetails);
                  }
                  this.initializeSearch(response.data.brand);
                  this.prepareSuggestionDetails(response.data.brand);
                  this.getAllSuggestion()
                }
              })
            }
          } else if (this.suggestionBrandId && this.suggestionBrandId != '') {
            if (this.managerAccessDetail) {
              this.managerHasMergeAccess = this.huddlesService.updateManagerHuddleMergeAccess(this.managerAccessDetail, this.brandDetails);
            }
            this.getAllSuggestion();
          }
        }
      }
    })
  }

  ngOnInit(): void {
    this.tableConfigs.defaultSortOnColumn = this.suggestionTable.fixedHeader[0];
  }

  ngAfterViewInit(): void {
    document.addEventListener('click', (event) => {
      const litmusfeedsearchel: any = document.getElementById('litmusfeedsearch');
      if (litmusfeedsearchel && litmusfeedsearchel != event.target && !litmusfeedsearchel.contains(event.target)) {
        this.showFilterFields = false;
        this.showSearchList = false;
      }
      if (this.litmusfeedsearch && this.litmusfeedsearch.nativeElement !== event.target && !this.litmusfeedsearch.nativeElement.contains(event.target)) {
        this.showFilterFields = false;
        this.showSearchList = false;
      }
    });
  }

  checkRequiredPamater(state: any) {
    if (state && _.hasIn(state, 'brandDetails') && !_.isEmpty(state.brandDetails) && _.hasIn(state, 'datePicker') && !_.isEmpty(state.datePicker) && _.hasIn(state, 'hierarchyStack') && !_.isEmpty(state.hierarchyStack)) {
      return true;
    } else {
      return false
    }
  }

  initializeSearch(brandDetails) {
    this.isSearchEnabled = false
    if (brandDetails && brandDetails.field_definitions && brandDetails.field_definitions.length) {
      const searchableFieldList = _.filter(brandDetails.field_definitions, (fieldDetail: any) => {
        return _.get(fieldDetail, "search.huddle");
      });

      if (searchableFieldList && searchableFieldList.length) {
        this.searchableFieldList = searchableFieldList
        this.defaultSearchField = searchableFieldList[0];
        this.selectedSearchField = searchableFieldList[0];
        this.suggestionSearch.selectedFilter = searchableFieldList[0]
        this.suggestionSearch.placeholder = "Search " + this.selectedSearchField.name
        this.isSearchEnabled = true
      }
    }
  }

  searchByField(event: any) {
    this.isOptionLoading = true
    const searchText = event.target.value;
    if (searchText && searchText != "") {
      const fieldId: string = this.selectedSearchField.field_id
      const param = {
        brand_id: _.get(this.suggestionsDetails, "brand._id"), //huddleActionReportVm.brandId,
        from: this.fromDate,
        to: this.toDate,
        limit: this.filterLimit,
        page_number: 1,
        search_type: fieldId, // type,
        search_text: searchText,
        custom_filter_list: this.getCustomFilterList()
      }

      this._feedService.getFeedAndUserfilter(param).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((response: any) => {
        this.searchResult = this.processSerchResult(fieldId, response.data);
        this.isOptionLoading = false;
      });

    } else {
      this.searchResult = {
        options: [{
          'displayText': "Start typing to search.",
          'text': "Start typing to search.",
          'id': '',
          isError: true
        }]
      }
      this.isOptionLoading = false;
    }


  }

  processSerchResult(fieldId: string, data: any) {
    var searchResults: any = [{ name: '', user_id: null }];
    var isPagination = false;
    // this.shouldShowFeedReset = true;
    if (data.code == 0) {
      // data can be in response to user data(eg. name, phone, email) or transaction data(tag_transaction_id etc)
      var options = data.data || data.feed;
      if (options && options.length) {
        searchResults = options;
        isPagination = (options.length < this.filterLimit) ? false : true;
      } else {
        searchResults = [{ name: 'No Results found', user_id: null, isError: true }];
        isPagination = false;
      }
    } else if (data.code == 4001) {
      // Something went wrong
      searchResults = [{ name: '', user_id: null, isError: true }];
    } else if (data.code == 4003) {
      // internal error, search type not supported
      searchResults = [{ name: 'Search type not supported', user_id: null, isError: true }];
    } else if (data.code == 5005) {
      // "Search not available"
      searchResults = [{ name: 'Search not available', user_id: null, isError: true }];
    } else if (data.code == 5000) {
      // "Unknown Exception, exception while performing search"
      searchResults = [{ name: 'Search not available', user_id: null, isError: true }];
    }

    return {
      options: _.map(searchResults, (item) => {
        if (this.isTextStartsWithTag(fieldId)) {
          if (item.feedback_request_data && !item.user_id) {
            return {
              'displayText': item.feedback_request_data[fieldId],
              'text': item.feedback_request_data[fieldId],
              'id': item.feedback_request_data[fieldId],
              isError: (item.isError) ? true : false
            }
          } else {
            return {
              'text': item.name,
              'id': item.user_id,
              isError: (item.isError) ? true : false
            }
          }
        } else {
          return {
            'displayText': item[fieldId],
            'text': (item['name'] ? item['name'] : '') + " " + (item["phone_number"] ? item["phone_number"] : '') + " " + (item["email_address"] ? item["email_address"] : ''),
            'id': item.user_id,
            isError: (item.isError) ? true : false
          }
        }
      }),
      pagination: {
        more: isPagination
      }
    }
  }

  isTextStartsWithTag(text) {
    // regular expression to check for tag_(it refers to transaction details)
    var searchPattern = new RegExp('^tag_');
    return searchPattern.test(text);
  }


  toggleSearchList() {
    this.showFilterFields = false;
    if (this.showSearchList) {
      this.showSearchList = false;
    } else {
      this.showSearchList = true;
      this.suggestionSearch.placeholder = this.suggestionSearch.placeholder;
      // this.searchText = '';
      this.searchResult = {
        options: [{
          'displayText': "Start typing to search.",
          'text': "Start typing to search.",
          'id': '',
          isError: true
        }]
      }
    }
  }

  toggleFilterFieldList() {
    this.showSearchList = false;
    if (this.showFilterFields) {
      this.showFilterFields = false;
    } else {
      this.showFilterFields = true;
    }

  }
  changeFilterField(field: any) {
    this.selectedSearchField = field;
    this.suggestionSearch.placeholder = "Search " + this.selectedSearchField.name
    this.searchText = '';
    this.showFilterFields = false;
  }


  getSuggestionforSelectedFields(item: any) {

    if (!item.isError) {
      this.pagingDetails.pageNumber = 1
      if (item.id || item.user_id) {
        const selectedFilterType = this.selectedSearchField.field_id
        this.searchText = item.displayText || item.text;
        if (this.isTextStartsWithTag(selectedFilterType)) {
          this.filters.fieldToSearchOn = this.selectedSearchField.field_id;
          this.filters.textToSearch = item.id;
        } else {
          this.filters["userId"] = item.id;
        }
        this.clearField.isEnabled = true;
        this.getAllSuggestion()
      } else {
        this.filters["fieldToSearchOn"] = null
        this.filters["textToSearch"] = null;
        this.filters["userId"] = null;
        this.searchText = '';
        this.clearField.isEnabled = false;
        this.getAllSuggestion()
      }
      this.showSearchList = false;
      this.showFilterFields = false;
    }
  }

  prepareSuggestionDetails(brandDetails: any) {
    var defaultRatio = 3;
    this.suggestionsDetails.brand = brandDetails;
    this.suggestionFilteredTagFields = []
    var fieldDefinitions = _.get(brandDetails, "field_definitions");
    _.each(fieldDefinitions, (fieldsObj) => {
      if (fieldsObj.download && !fieldsObj.is_deleted && fieldsObj.field_id != "created_date") {
        this.suggestionFilteredTagFields.push({
          "field_id": "litmus_processed_data." + fieldsObj.field_id,
          "name": fieldsObj.name,
          "download": fieldsObj.download
        })
      }
    })
    fieldDefinitions = _.filter(fieldDefinitions, function (fieldDefinition) {
      return (_.get(fieldDefinition, "visibility_config.list") != false) ? true : false;
    });
    let totalRatio = fieldDefinitions.map(function (fieldDefinition) {
      if (_.get(fieldDefinition, "cell_ratio.list")) {
        return _.get(fieldDefinition, "cell_ratio.list");
      } else {
        return 0;
      }
    }).reduce(function (op1, op2) {
      return op1 + op2;
    })

    this.suggestionsDetails.editColumnRatio = ((10 - totalRatio) / totalRatio) * 100;
    this.suggestionsDetails.fieldDefinitions = _.map(Helpers.deepClone(fieldDefinitions), function (fieldDefinition) {
      fieldDefinition["td_width"] = ((_.get(fieldDefinition, "cell_ratio.list") || defaultRatio) / totalRatio) * 100;
      return fieldDefinition;
    });

    const columns: any = _.filter(Helpers.deepClone(fieldDefinitions), (field: any) => {
      return (field.group_id)
    })

    this.suggestionTable.header = _.map(columns, (field: any) => {
      let column: any = {
        header: field.title || field.name,
        uniqueId: field.field_id,
        width: this.getColumnWidth(field),
        maxWidth: this.getColumnWidth(field),
        minWidth: this.getColumnWidth(field),
        isSortingEnabled: false,
        data_type: field.data_type,
        // isClickable: true,
        style: {
          header: 'flex-start',
          row: 'flex-start',
          textWrap: 'wrap'
        },
        textStyle: {
          whiteSpace: 'wrap',
        }
      }
      if (_.get(field, 'sort.list') == true) {
        if (field.data_type == "date") {
          column.uniqueId = 'formated_' + field.field_id
          column.sortId = field.field_id + "_in_ms";
          column.sort_order = 'desc';
          this.tableConfigs.defaultSortOnColumn = column;
        }
        column.isSortingEnabled = true;
      }
      return column
    })

    this.suggestionTable.fixedHeader = this.suggestionTable.header.splice(0, 2);
  }

  getColumnWidth(column: any) {
    if (column.field_id == "tag_ltms_huddle_suggestions_for_process_imporvement_product_and_function_1") {
      return '270px'
    } else if (column.field_id == "tag_ltms_huddle_suggestions_for_process_imporvement_sub_reason_1" || column.field_id == "tag_ltms_huddle_suggestions_for_process_imporvement_theme_1") {
      return '300px'
    } else if (column.field_id == "tag_ltms_huddle_suggestions_for_process_imporvement_product_and_function_1") {
      return '230px'
    } else if (column.field_id == "tag_ltms_huddle_c562e071-08a6-4ac9-9eb5-54ec4b1b48f0_1") {
      return '400px'
    } else if (_.get(column, 'dom_options.type') == "multi-line") {
      return '600px'
    } else if (column.data_type == 'date' || column.field_id == "tag_ltms_huddle_3082eef8-baba-409d-b05e-99e960d760d889-44") {
      return '150px'
    } else {
      return '200px'
    }

  }

  toggleMergeSuggestion(event: any, type?: any) {
    event.preventDefault();
    if (!this.isMergSuggestionActive) {
      this.isMergSuggestionActive = true;
      this.tableConfigs.showCheckbox = true;
    }
  }

  toggleExpand(index: number) {
    if (this.expandedRowIndex === index) {
      this.expandedRowIndex = null;
    } else {
      this.expandedRowIndex = index;
    }
  }

  toggleFullScreen(): void {
    const elem = document.documentElement;
    if (!document.fullscreenElement) {
      elem.requestFullscreen().catch(err => {
        console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
      });
    } else {
      document.exitFullscreen().catch(err => {
        console.error(`Error attempting to disable full-screen mode: ${err.message} (${err.name})`);
      });
    }
  }

  // This function calls download/initiate_huddle_download API and these are the required params for this API call
  suggestionResponseDownload(dates?: { startDate: string; endDate: string; }): void {
    const reqBody = {
      brand_id: this.brandId,
      es_index_brand_id: this.suggestionBrandId,
      from: this.fromDate,
      to: this.toDate,
      filters: [
        {
          is_tag_filter: true,
          key: "tag_private_group_" + this.managerAccessDetail.level,
          value: [this.managerAccessDetail.value],
        },
      ],
      fields: (this.suggestionFilteredTagFields && this.suggestionFilteredTagFields.length) ? this.suggestionFilteredTagFields : [],
      tabName: "escalations",
    };
    this.huddlesService.huddleDownload(reqBody).subscribe(
      (response: any) => {
        this._toast.showPopup('SUCCESS', 'Success', 'Download Request Created Successfully', 2000)
      },
      (error) => {
        console.error('Error fetching huddle suggestion data:', error);
      }
    );
  }

  getAllSuggestion(params?: any, escalation?: any): void {
    // this.pagination.currentPage = pageNumber;
    this.escalationList = [];
    this.resetDataBasedOnParams(params);
    this.getParametersForAPI((apiParams) => {
      this._feedService.getFeedsByFilter(apiParams).subscribe(
        (response: any) => {
          if (response.code == 0 && _.hasIn(response, 'data.feed') && !_.isEmpty(response.data.feed)) {
            this.processSuggestionData(response.data, params, escalation)
          } else {
            if (!escalation) {
              this.isSuggestionAvailble = false
              this.suggestionTable.rows = []
              this.isLoading = false;
              this.isDataLoaded = true;
            }

          }

        },
        (error) => {
          this.isLoading = false;
          this.isDataLoaded = true;
          console.error('Error fetching suggestions data:', error);
        }
      );
    })

  }

  resetDataBasedOnParams(params: any) {
    var prevPageNumber = this.pagingDetails.pageNumber;
    if (_.get(params, "resetList") == true && !_.get(params, "fetchChild")) {
      this.escalationList = [];
      this.pagingDetails.pageNumber = 1;
    }
    if (_.get(params, "resetSort") != false) {
      this.filters.fieldToSortOn = this.filters.fieldSortOrder = null;
      this.filters.dateSortOrder = "desc";
    }
    
    if (_.get(params, "pageNext") === undefined) {
      this.pagingDetails.pageNumber = prevPageNumber;
    }
    if (_.get(params, "pageNext") == true && Math.ceil(this.pagingDetails.totalCount / 10) !== prevPageNumber) {
      this.pagingDetails.pageNumber = prevPageNumber + 1;
    }
    if (_.get(params, "pageNext") !== undefined && _.get(params, "pageNext") != true && prevPageNumber > 1) {
      this.pagingDetails.pageNumber = prevPageNumber - 1;
    } else {
      this.filters.nonExistantFields = this.filters.defaultNonExistantField;
      this.customFilterList = null;
    }

    // {"fetchChild": true, "parentId": _.get(escalation, "_id")}
    if (_.get(params, "fetchChild")) {
      this.filters.nonExistantFields = null;
      this.customFilterList = [{
        'field': 'litmus_processed_data.tag_private_parent_feed_id.keyword',
        'value': params.parentId,
        'hasPrefix': true
      }]
    }
  }

  getParametersForAPI(cb) {
    var params = {
      brandId: _.get(this.suggestionsDetails, "brand._id"),
      from: this.fromDate,
      to: this.toDate,
      dataSource: 2, // 2: Elastic search 1: Mongo
      dateFilterType: 2, // 2: By feed's created Date, 1: By request date
      dataSortOrder: this.filters.dateSortOrder, // desc: newest first, asc: oldest first 
      includeExcludedFeeds: false,
      limit: this.pagingDetails.pageSize,
      pageNumber: this.pagingDetails.pageNumber,
      nonExistantFields: this.filters.nonExistantFields,
      searchType: this.filters.fieldToSearchOn || this.selectedSearchField.field_id,
      searchText: this.filters.textToSearch,
      fieldToSortOn: this.filters.fieldToSortOn,
      fieldSortOrder: this.filters.fieldSortOrder,
      customFilterList: this.getCustomFilterList()
    }
    cb(params)
  }


  getCustomFilterList() {
    if (!this.customFilterList) {
      this.customFilterList = [];
    }
    if (_.get(Helpers, "hierarchyStack.length")) {
      let hierarchyStack = _.map(Helpers.hierarchyStack, (filter: any) => {
        return {
          "field": filter.field_id,
          "value": filter.group_key[0]
        }
      })
      this.customFilterList = this.customFilterList.concat(hierarchyStack);
    } else if (this.managerAccessDetail && this.managerAccessDetail?.level && this.managerAccessDetail?.value) {
      this.customFilterList.push({
        "field": this.managerAccessDetail.level,
        "value": this.managerAccessDetail.value
      })
    }

    if (_.get(Helpers, "huddleFilters.escalation")) {
      for (var key in Helpers.huddleFilters.escalation) {
        if (Helpers.huddleFilters.escalation[key] && Helpers.huddleFilters.escalation[key].length) {
          this.customFilterList.push({
            "field": "litmus_processed_data." + key + ".keyword",
            "value": Helpers.huddleFilters.escalation[key],
            'hasPrefix': true
          })
        }
      }
    }
    // Remove duplicates based on field
    this.customFilterList = _.uniq(this.customFilterList, "field");
    return this.customFilterList;
  }


  processSuggestionData(data: any, params?: any, parentSuggestion?: any) {
    if (data.feed && data.feed.length) {
      var feeds = Helpers.deepClone(_.get(data, "feed"));
      var fieldDefinitions = Helpers.deepClone(_.get(this.suggestionsDetails, "brand.field_definitions"));

      var parentEscalation: any = null;
      if (_.get(params, "fetchChild") && !_.isEmpty(parentSuggestion)) {
        // parentEscalation = _.filter(this.escalationList, { "_id": _.get(params, "parentId") });
        parentEscalation = [Helpers.deepClone(parentSuggestion)]
        if (parentEscalation.length) {
          parentEscalation[0]["children"] = [];
        }
      }

      var escalation: any = {};
      var dataToShow: any = null;
      _.each(feeds, (feed) => {
        escalation = {};
        _.each(fieldDefinitions, (fieldDefinition) => {
          if (_.get(fieldDefinition, "group_id") && _.get(fieldDefinition, "visibility_config.list") != false) {
            var fieldIdToUpdate = null
            if (_.get(fieldDefinition, "datasource.options.save_as_object") == true) {
              fieldIdToUpdate = _.get(fieldDefinition, "datasource.options.data_to_save_in.display_field")
            } else {
              fieldIdToUpdate = fieldDefinition['field_id']
            }

            dataToShow = _.get(feed, fieldIdToUpdate) ||
              _.get(feed, "litmus_processed_data.tag_" + fieldIdToUpdate) ||
              _.get(feed, "litmus_processed_data." + fieldIdToUpdate) ||
              _.get(feed, "feedback_request_data.tag_" + fieldIdToUpdate) ||
              _.get(feed, "feedback_request_data." + fieldIdToUpdate) ||
              _.get(feed, "litmus_processed_data.tag_" + fieldDefinition['field_id']) ||
              _.get(feed, "litmus_processed_data.tag_tag_" + fieldDefinition['field_id']);
            escalation[fieldDefinition['field_id']] = dataToShow;
            if (fieldDefinition['field_id'] == "tag_meeting_name") {
              escalation[fieldDefinition['field_id']] = (dataToShow) ? dataToShow.slice((dataToShow.indexOf('-') + 1), dataToShow.lastIndexOf('-')).trim() : "NA";
            }
          }
        });
        feed.key = feed._id
        feed.formated_created_date = moment(feed.created_date).format('DD-MMM-YYYY')
        feed.created_date_in_ms = moment(feed.created_date).valueOf();
        if (_.hasIn(feed, 'litmus_processed_data.tag_private_children_ids') && !_.isEmpty(feed.litmus_processed_data.tag_private_children_ids)) {
          feed.drilldown = [];
        }
        if (feed.tags) {
          Object.assign(feed.tags, Helpers.deepClone(escalation));
        } else {
          feed.tags = Helpers.deepClone(escalation);
        }
        // 'escalation' will contain only field_definition's data which should be visible for the escalation list
        if (parentEscalation && parentEscalation.length) {
          // "isDataForModal": true escalationsToBeMerged
          if (_.get(params, "isDataForModal")) {
            this.suggestionToBeMerged[feed._id] = Object.assign(escalation, feed)
          } else {
            parentEscalation[0]["children"].push(Object.assign(escalation, feed))

          }
        } else {
          feed.editable = true;
          this.escalationList.push(Object.assign(escalation, feed));
        }

      });

      if (!parentSuggestion) {
        this.suggestionTable.rows = [...this.escalationList];
        this.updatePagingDetails(data.total_feeds, this.pagingDetails.pageNumber)
        this.isLoading = false;
        this.isDataLoaded = true;
        this.isSuggestionAvailble = true;
        // Update total data for pagination
        // this.updatePagingDetails(data.total_feed,this.pagingDetails.pageNumber)
      } else {
        if (parentEscalation.length && parentEscalation[0]["children"] && parentEscalation[0]["children"].length) {
          parentSuggestion.drilldown = [...parentEscalation[0]["children"]]

          parentSuggestion.isLoading = false;
        }
      }


    } else {
      if (!parentSuggestion) {
        this.isLoading = false;
        this.isDataLoaded = true;
        this.isSuggestionAvailble = false;
      }
    }

  }


  getChildEscalations(escalation: any) {
    if (_.get(escalation, '_id')) {
      this.getAllSuggestion({
        "fetchChild": true,
        "parentId": _.get(escalation, "_id")
      }, escalation)
    }
  }

  updateSelectSuggestion(event: any) {
    if (event && event._id) {
      if (event.checked) {
        this.suggestionToBeMerged[event._id] = event;
      } else {
        delete this.suggestionToBeMerged[event._id]
      }
    }
    this.isMergeButtonEnabled = (!_.isEmpty(this.suggestionToBeMerged) && Object.keys(this.suggestionToBeMerged).length >= 2) ? true : false;
  }


  proceedToMerge() {
    this.modalDetail = {
      'fieldDefinitionsForList': this.suggestionsDetails.fieldDefinitions,
      'brandDetail': _.get(this.suggestionsDetails, "brand"),
      'mergedData': this.suggestionToBeMerged,
      'mode': "Merge",
      'modalHeader': "Merge Suggestions"
    };
    this.showEditModal = true;
  }

  closeEditModal() {
    this.showEditModal = false;
  }

  cancelMerge() {
    this.suggestionToBeMerged = {};
    this.isMergSuggestionActive = false;
    this.tableConfigs.showCheckbox = false;
    this.modalDetail = {};
    this.showEditModal = false;
  }

  editSuggestion(event: any) { 
    this.updateEscalation(event)
  }


  updateEscalation(escalation) {
    var fieldDefinitionForEdit = this.getFDForNonMergedEscalations(_.get(this.suggestionsDetails, "brand.field_definitions"));
    this.modalDetail = {
      "fieldDefinitionsForList": this.suggestionsDetails.fieldDefinitions,
      "fieldDefinitions": fieldDefinitionForEdit,
      "brandDetail": _.get(this.suggestionsDetails, "brand"),
      "mergedData": this.suggestionToBeMerged,
      "parentBrand": this.brandDetails,
      "issueDetail": escalation,
      "mode": "Update",
      'modalHeader': "Suggestion"
    };
    this.showEditModal = true;
  }

  getFDForNonMergedEscalations(fieldDefinitions) {
    var response: any = [];
    _.each(Helpers.deepClone(fieldDefinitions), function (fd) {

      if (fd["dom_options"]) {
        if (_.get(fd, "visibility_config.edit") != true) {
          fd["dom_options"]["show_as_label"] = true;
          fd["dom_options"]["show_as_label_class"] = "col col-lg-8 col-md-8 col-sm-8 col-xs-8 padding-0 ltms-huddle-escalations__table-td-text"; //col-lg-3 col-md-3 col-sm-3 col-xs-3
        } else {
          fd["dom_options"]["label_class"] = "col col-lg-4 col-md-4 col-sm-4 col-xs-4 padding-0 huddle-escalations-edit__label-text";
        }
      }
      response.push(fd);
    })
    return response;
  }


  updatePagingDetails(totalfeeds: number, pageNumber: number) {
    if (totalfeeds > this.pagingDetails.pageSize) {
      pageNumber = (pageNumber > 0) ? pageNumber : 1;
      let start = (pageNumber > 0) ? ((pageNumber - 1) * this.pagingDetails.pageSize) + 1 : 1;
      let end = (pageNumber > 0) ? (pageNumber * this.pagingDetails.pageSize) : this.pagingDetails.pageSize;
      end = (pageNumber >= this.pagingDetails.totalpages) ? ((pageNumber - 1) * this.pagingDetails.pageSize) + this.suggestionTable.rows.length : end;
      this.pagingDetails = {
        start: start,
        end: end,
        pageSize: 10,
        pageNumber: pageNumber,
        total: totalfeeds,
        totalpages: Math.ceil(totalfeeds / 10)
      }
    } else {
      this.pagingDetails = {
        start: (totalfeeds > 0) ? 1 : 0,
        end: (totalfeeds > 0) ? totalfeeds : 0,
        pageSize: 10,
        pageNumber: 1,
        total: (totalfeeds > 0) ? totalfeeds : 0,
        totalpages: 1
      }
    }
    this.pagingDetails.total = totalfeeds;
    this.pagingButtons.isNext = false;
    this.pagingButtons.isFirst = false;
    this.pagingButtons.isPrevious = false;
    this.pagingButtons.isLast = false;

    if (this.pagingDetails.pageNumber < this.pagingDetails.totalpages) {
      this.pagingButtons.isNext = true;
      this.pagingButtons.isLast = true;
    }

    if (this.pagingDetails.pageNumber > 1) {
      this.pagingButtons.isFirst = true;
      this.pagingButtons.isPrevious = true;
    }

    if (this.pagingDetails.total < this.pagingDetails.pageSize) {
      this.pagingButtons.isNext = false;
      this.pagingButtons.isFirst = false;
      this.pagingButtons.isPrevious = false;
      this.pagingButtons.isLast = false;
    }
  }

  paginateFeedList(pagingType: string) {
    if (pagingType == 'next') {
      this.pagingDetails["pageNumber"]++;
    } else if (pagingType == 'previous') {
      this.pagingDetails["pageNumber"]--;
    } else if (pagingType == 'first') {
      this.pagingDetails["pageNumber"] = 1;
    } else if (pagingType == 'last') {
      this.pagingDetails["pageNumber"] = this.pagingDetails.totalpages;
    }
    this.getAllSuggestion({ resetSort: false })
  }

  getSortedData(column: any) {
    this.suggestionTable.fixedHeader[0].sort_order = (column && column.sort_order) ? column.sort_order : 'desc';
    this.tableConfigs.defaultSortOnColumn = this.suggestionTable.fixedHeader[0]
    this.filters.dateSortOrder = (column && column.sort_order) ? column.sort_order : 'desc';
    this.getAllSuggestion({ resetSort: false });
  }
}
